import dayjs from 'dayjs';

const msInDay = 86400000;
const msInTwoDays = 172800000;
const msInThreeMoth = 7776000000;

const getRange = deltaMs => {
  const now = Date.now();

  return {
    from: now - deltaMs,
    to: now,
  };
};

const getStrictDaysRange = deltaMs => {
  const { from, to } = getRange(deltaMs);

  return {
    from: dayjs(from).startOf('day').valueOf(),
    to: dayjs(to).endOf('day').valueOf(),
  };
};

export const getDayRange = () => getRange(msInDay);
export const getTwoDayRange = () => getRange(msInTwoDays);
export const getThreeMonthRange = () => getStrictDaysRange(msInThreeMoth);

export const last24 = 'last_24_hours';
export const last48 = 'last_48_hours';
export const rangeName = 'from';
